// import axios from "../../../core/api/http-common";

const ON_CREATE_QUESTIONS = "/class/admission/test/create/questions";
const ON_GET_QUESTIONS_WITH_PAGINATION =
  "/class/admission/test/get/questions/with/pagination";
const ON_RELEASE_QUESTIONS = "/class/admission/test/release/questions";
const ON_ARCHIVE_QUESTIONS = "/class/admission/test/archive/questions";

export function onCreateClassAdmissionTestQuestions(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_CREATE_QUESTIONS, data, {
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onGetClassAdmissionTestQuestionsWithPaginationByClassId(
  axiosPrivate,
  data,
  signal
) {
  const _data = {
    class_id: data?.stream_id,
    rows_per_page: data?.rows_per_page,
    current_page: data?.current_page,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_GET_QUESTIONS_WITH_PAGINATION, { params: _data, signal: signal })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onReleaseClassAdmissionTestQuestion(
  axiosPrivate,
  class_test_question_id,
  is_activated
) {
  const _data = {
    class_test_question_id: class_test_question_id,
    is_activated: is_activated,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_RELEASE_QUESTIONS, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function onArchiveClassAdmissionTestQuestion(
  axiosPrivate,
  class_test_question_id,
  is_deleted
) {
  const _data = {
    class_test_question_id: class_test_question_id,
    is_deleted: is_deleted,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.patch(ON_ARCHIVE_QUESTIONS, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const ON_GET_ADMISSION_TEST_STATUS = "/class/admission/test/get/status";

export function onGetAdmissionTestStatus(axiosPrivate, data, signal) {
  const _data = {
    inscription_id: data?.inscription_id,
    stream_id: data?.stream_id,
    dates: data?.dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_GET_ADMISSION_TEST_STATUS, { params: _data, signal: signal })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// Creating a new admission test question set
const ON_NEW_ADMISSION_TEST = "/class/admission/test/new/assessment";
export function onCreateStudentAdmissionTest(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_NEW_ADMISSION_TEST, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// get the current/next question or one by one question to answer during the test
const ON_GET_ADMISSION_TEST_CURRENT_QUESTION =
  "/class/admission/test/current/question";
export function onGetAdmissionTestCurrentQuestion(axiosPrivate, data, signal) {
  const _data = {
    class_test_id: data?.class_test_id,
    dates: data?.dates,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.get(ON_GET_ADMISSION_TEST_CURRENT_QUESTION, {
        params: _data,
        signal: signal,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
// The function allow to answer the current/next question during the test
const ON_ANSWER_ADMISSION_TEST_CURRENT_QUESTION =
  "/class/admission/test/answering/current/question";
export function onAnsweringAdmissionTestCurrentQuestion(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate.post(ON_ANSWER_ADMISSION_TEST_CURRENT_QUESTION, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//
